import React from 'react';
import { gql } from '@apollo/client/core';
import { useQuery } from '@apollo/client';
import { Col, Typography } from 'antd';
import { useLocalization } from '../../../../util/useLocalization';
import { Locale } from '../../../../../localization/LocalizationKeys';
import { EntityTabFieldProps } from './EntityTabFieldsTypes';
import {
  SiteExternalIdsQueryQuery,
  SiteExternalIdsQueryQueryVariables
} from '../../../../../gql/typings';


const SiteExternalIdsTabField: React.FC<EntityTabFieldProps> = (props) => {
  const localization = useLocalization();
  const { data, loading } = useQuery<SiteExternalIdsQueryQuery, SiteExternalIdsQueryQueryVariables>(DATA_QUERY, {
    variables: { siteId: props.recordId },
  });

  const nodes = data?.site?.externalIds.nodes ?? [];

  const displayHeading = (e: NonNullable<SiteExternalIdsQueryQuery['site']>['externalIds']['nodes']['0']) => {
    if (e.type.isHeadingKey) return localization.formatMessageByStr(e.type.heading);
    return e.type.heading;
  };

  return (
    <>
      {(data?.site?.externalIds.nodes ?? []).map(eId => (
        <React.Fragment key={eId.id}>
          <Col md={6} sm={8}>
            <strong><span style={{ wordBreak: 'break-word' }}>{displayHeading(eId)}</span></strong>:
          </Col>
          <Col md={18} sm={16}>
            <Typography.Text copyable>
              {eId.externalId}
            </Typography.Text>
          </Col>
        </React.Fragment>
      ))}
      {nodes.length === 0 && !loading && (
        <Col span={24}>
          {localization.formatMessage(Locale.Text.No_external_IDs)}
        </Col>
      )}
    </>
  );
};

const DATA_QUERY = gql`
  query SiteExternalIdsQuery($siteId: Int!) {
    site(siteId: $siteId) {
      id
      externalIds {
        hash
        nodes {
          id
          externalId
          type {
            id
            heading
            isHeadingKey
            description: note
          }
        }
      }
    }
  }
`;

export default SiteExternalIdsTabField;
